module.exports = __webpack_public_path__ + "img/5_82.92a48040.png";